/**
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2023, Zumper
 * @description  selectors for Ratings and Reviews
 */

import type { State } from '@zcode/state-type'
import { compose } from 'redux'

export const selectRatingsAndReviews = (state: State) => state.ratingsAndReviews

export const selectDetailRatingsAndReviews = compose(
  (detailRatingsAndReviews) => detailRatingsAndReviews?.detail,
  selectRatingsAndReviews
)

export const selectDetailRatingsAndReviewsMeta = compose(
  (ratingsAndReviews) => ratingsAndReviews?.detailMeta,
  selectRatingsAndReviews
)

export const selectDetailReviews = compose((data) => data?.reviews, selectDetailRatingsAndReviews)

export const selectReviewsTotalCount = compose(
  (data) => data?.totalCount,
  selectDetailRatingsAndReviews
)

export const selectDetailRatingsAndReviewsFetched = compose(
  (meta) => meta?.fetched,
  selectDetailRatingsAndReviewsMeta
)

export const selectModalRatingsAndReviews = compose(
  (ratingsAndReviews) => ratingsAndReviews?.modal,
  selectRatingsAndReviews
)

export const selectModalRatingsAndReviewsMeta = compose(
  (ratingsAndReviews) => ratingsAndReviews?.modalMeta,
  selectRatingsAndReviews
)

export const selectModalReviews = compose((data) => data?.reviews, selectModalRatingsAndReviews)

export const selectModalReviewsCounts = compose(
  (data) => data?.totalCount,
  selectModalRatingsAndReviews
)

export const selectModalRatingsAndReviewsFetched = compose(
  (meta) => meta?.fetched,
  selectModalRatingsAndReviewsMeta
)

export const selectRatingsAndReviewsModalCounts = compose(
  (ratingsAndReviews) => ratingsAndReviews?.modalCounts,
  selectRatingsAndReviews
)

export const selectRatingsAndReviewsModalCountsMeta = compose(
  (ratingsAndReviews) => ratingsAndReviews?.modalCountsMeta,
  selectRatingsAndReviews
)

export const selectRatingsAndReviewsModalCountsFetched = compose(
  (meta) => meta?.fetched,
  selectRatingsAndReviewsModalCountsMeta
)
